import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import classes from "./styles.module.scss";
import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastContainer />
    <div className={classes.global}>
      <App />
    </div>
  </React.StrictMode>
);


